import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Btn, { ButtonStyle } from '@/components/input/Btn/Btn.vue';
import { onMounted } from 'vue';
type ButtonSize = 'btn-ss' | 'btn-sm' | 'btn-md' | 'btn-lg' | '';

// ClickFuncの型を定義(Function型）
declare type ClickFunc = (args?: any) => any;

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'TextButton',
  props: {
    onClick: {},
    buttonStyle: { default: 'btn-primary' },
    size: { default: 'btn-md' },
    disabled: { type: Boolean, default: false },
    toolTipValue: { default: '' },
    eventModifier: { default: '' }
  },
  setup(__props: any) {

const props = __props;
// 変数

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Btn, {
    class: _normalizeClass(props.size),
    "button-style": props.buttonStyle,
    disabled: props.disabled,
    "tool-tip-value": props.toolTipValue,
    "event-modifier": props.eventModifier,
    "on-click": props.onClick
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ], undefined, true),
    _: 3
  }, 8, ["class", "button-style", "disabled", "tool-tip-value", "event-modifier", "on-click"]))
}
}

})